/* eslint-disable linebreak-style */
import constants from '../constants'

export default (state = { }, action) => {
  switch (action.type) {
    case constants.LOGIN:
      return {
        ...state,
        adminData: action.payload.data,
        token: action.payload.token,
        resStatus: action.payload.resStatus,
        resMessage: action.payload.resMessage
      }
    case constants.TOKEN_LOGIN:
      return {
        ...state,
        token: action.payload.token,
        adminData: action.payload.adminData
      }
    case constants.LOGOUT:
      return {
        token: undefined
      }
    // case constants.SEND_OTP:
    //   return {
    //     sendotpStatus: action.payload.resStatus,
    //     sendotpMessage: action.payload.resMessage
    //   }
    // case constants.RESET_PASSWORD:
    //   return {
    //     resetpwdStatus: action.payload.resStatus,
    //     resetpwdMessage: action.payload.resMessage
    //   }
    // case constants.RESET_TOKEN_VERIFY:
    //   return {
    //     tokenVerifyStatus: action.payload.resStatus,
    //     tokenVerifyMessage: action.payload.resMessage
    //   }
    case constants.CLEAR_MESSAGE:
      return {
        sendotpMessage: '',
        resetpwdMessage: '',
        tokenVerifyMessage: ''
      }
    case constants.CLEAR_AUTH_PROPS:
      return {
        adminData: {},
        resStatus: false,
        resMessage: '',
        sendotpStatus: false,
        sendotpMessage: '',
        resetpwdStatus: false,
        resetpwdMessage: '',
        tokenVerifyMessage: '',
        tokenVerifyStatus: false
      }
    default:
      return state
  }
}
